import { Stack } from '@mui/material'
import { com } from '@eidu/web'
import Description = com.eidu.sharedlib.form.definition.Description
import { withKey } from '../../util/withKey'
import TrimmedTextField from './TrimmedTextField'

type DescriptionItemProps = {
  item: Description
  onChange?: (newItem: Description) => void
  onDelete?: () => void
}

const DescriptionItem: React.FC<DescriptionItemProps> = ({ item, onChange }) => (
  <Stack
    direction="row"
    spacing={2}
    alignItems="center"
    sx={{
      p: 1,
      bgcolor: 'background.paper',
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'divider',
    }}
  >
    <TrimmedTextField
      fullWidth
      multiline
      value={item.text}
      onChange={(e) => onChange?.(withKey(item.copy(e.target.value), item))}
      variant="standard"
      placeholder="Enter description"
      disabled={!onChange}
    />
  </Stack>
)

export default DescriptionItem
